
export class ModalWindow {

   constructor() {

      const overlays = document.querySelector('.overlays');
      this.panel = overlays.createElement('div', 'overlay modal-window');

   }

   close() {
      this.panel.classList.remove('active');
      const cf = (event) => {
         event.currentTarget.removeEventListener('transitionend', cf);
         this.panel.remove();
      };
      if (this.panel.classList.contains('modal-window')) {
         this.panel.addEventListener('transitionend', cf);
      }
      else {
         this.panel.remove();
      }
   }

   show() {
      this.panel.classList.add('active');
   }


}


export class ModalTiteledWindow extends ModalWindow {

   constructor() {
      super();
      this.panel.innerHTML = '<div class="content">'
                           +    '<div class="head">'
                           +       '<div class="title"></div>'
                           +       '<i class="icon-left-small btn-back"></i>'
                           +    '</div>'
                           +    '<div class="body"></div>'
                           + '</div>';
      
      this.panel.querySelector('.btn-back').onclick = () => this.close();
                           
   }


   setTitle(title) {
      this.panel.querySelector(".title").innerHTML = title;
   }

   setBody(html) {
      this.panel.querySelector(".body").innerHTML = html;
   }

   appendToBody(node) {
      this.panel.querySelector(".body").appendChild(node);
   }

   addClass(cls) {
      this.panel.classList.add(cls);
   }

   
   setupHelp(app) {

      this.panel.querySelectorAll('.help').forEach(el => {
         el.onclick = (event) => {
            const selector = event.currentTarget.getAttribute('selector');
            if (selector) app.showHelp(selector);
         }
      });

   }
   

}
